import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fi-icon-light-bolt",
  "use": "fi-icon-light-bolt-usage",
  "viewBox": "0 0 8 12.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 12.8\" id=\"fi-icon-light-bolt\">\n  <path id=\"fi-icon-light-bolt_bolt\" d=\"M7.39,4H4.5L5.57.755A.6.6,0,0,0,4.99,0H1.39A.6.6,0,0,0,.795.52l-.8,6A.6.6,0,0,0,.59,7.2H3.557L2.4,12.062a.6.6,0,0,0,1.1.437l4.4-7.6A.6.6,0,0,0,7.39,4Z\" transform=\"translate(0.011)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol